<div class="bg-page-container lead-section-{{leadSection?.code}} h-100">
   <div class="h-100">
      <!-- p-0 p-md-2 ps-lg-5 pe-lg-5 pb-lg-5 mb-3-->
      <!--<app-lms-breadcrumb></app-lms-breadcrumb>-->
      <!--hiding breadcrumb till we decide what to do -->

      <router-outlet></router-outlet>
   </div>
</div>
